var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonApprove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 9C4 6.23858 6.23858 4 9 4C11.7614 4 14 6.23858 14 9C14 10.5202 13.3215 11.882 12.2509 12.7991C14.4798 13.97 16 16.3075 16 19C16 19.5523 15.5523 20 15 20C14.4477 20 14 19.5523 14 19C14 16.2386 11.7614 14 9 14C6.23858 14 4 16.2386 4 19C4 19.5523 3.55228 20 3 20C2.44772 20 2 19.5523 2 19C2 16.3075 3.52021 13.97 5.74913 12.7991C4.67847 11.882 4 10.5202 4 9ZM9 6C7.34315 6 6 7.34315 6 9C6 10.6569 7.34315 12 9 12C10.6569 12 12 10.6569 12 9C12 7.34315 10.6569 6 9 6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.69 6.72385C22.0897 6.34279 22.1049 5.70981 21.7239 5.31004C21.3428 4.91027 20.7098 4.8951 20.31 5.27616L17.6718 7.79092L16.7191 6.80508C16.3353 6.40794 15.7022 6.39712 15.3051 6.78091C14.9079 7.16471 14.8971 7.79778 15.2809 8.19492L16.9238 9.89492C17.3057 10.2901 17.935 10.3031 18.3328 9.92385L21.69 6.72385Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonApprove);
export default __webpack_public_path__ + "static/media/person-approve.69f6f8b0529b0a61adc2ad82f6ef2698.svg";
export { ForwardRef as ReactComponent };